import createAxios from './api'

const PATH = 'rssp/v1/credentials'

export default {
  async createCredential(req) {
    const axios = await createAxios(true)
    await axios.post(`${PATH}`, req)
  },

  async getCredential(id) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/${id}`)

    return resp.data
  },

  async getCertificateInfo(pem) {
    const axios = await createAxios()
    const resp = await axios.post(`${PATH}/certificateInfo`, { pem })

    return resp.data
  },

  async listMyCredentials(status, q, pageRequest) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/self`, {
      params: {
        status,
        q: q?.toString() || '',
        ...pageRequest
      }
    })

    return resp.data
  },

  async listCredentials(userId, q, pageRequest) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}`, {
      params: {
        userId,
        q: q?.toString() || '',
        ...pageRequest
      }
    })

    return resp.data
  },

  async listMyActivatedCredentials() {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/self?status=ACTIVATED`)

    return resp.data
  },

  async updateCredential(id, req) {
    const axios = await createAxios()
    await axios.put(`${PATH}/${id}`, req)
  },

  async deleteCredential(id) {
    const axios = await createAxios()
    await axios.delete(`${PATH}/${id}`)
  },

  async activateCredential(id, req, timeOut) {
    const axios = await createAxios(true, timeOut)
    await axios.post(`${PATH}/${id}/activate`, req)
  },

  async changePassword(id, req, timeOut) {
    const axios = await createAxios(true, timeOut)
    await axios.post(`${PATH}/${id}/changePassword`, req)
  },

  async unlock(id, req, timeOut) {
    const axios = await createAxios(true, timeOut)
    await axios.post(`${PATH}/${id}/unlock`, req)
  },

  async changePuk(id, req, timeOut) {
    const axios = await createAxios(true, timeOut)
    await axios.post(`${PATH}/${id}/changePuk`, req)
  },

  async replaceCertificateChain(id, certChain) {
    const axios = await createAxios()
    await axios.put(`${PATH}/${id}/certificateChain`, certChain)
  },

  async clearCredentialPreauthorization(id) {
    const axios = await createAxios()
    await axios.post(`${PATH}/${id}/clearPreauthorization`)
  }
}
